import { BRAND_GLYPH, BRAND_NAME } from "./constants.js";
import { highlighter } from "./highlighter.js";

export const printBanner = (version: string): void => {
  console.log(
    `${highlighter.brand(BRAND_GLYPH)} ${highlighter.bold(BRAND_NAME)} ${highlighter.dim(version)}`,
  );
  console.log();
};
